<template>
  <sub-page :title="view === 'list' ? '待遇资格认证' : current.name" @back="onPageBack">
    <!-- ============ 险种列表 ============ -->
    <div class="certify-page" v-if="view === 'list'">
      <div class="page-tip">请选择需要办理待遇资格认证的险种：</div>
      <div class="list-body">
        <div class="list-item" v-for="(item, idx) in types" :key="item.key" @click="openDetail(item)">
          <span class="item-text">{{ item.name }}</span>
          <span :class="['status-tag', item.eligible ? (item.certified ? 'tag-green' : 'tag-orange') : 'tag-gray']">
            {{ item.eligible ? (item.certified ? '已认证' : '待认证') : '不可办理' }}
          </span>
          <svg viewBox="0 0 24 24" class="arrow-icon"><path d="M9 18 L15 12 L9 6" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </div>
    </div>

    <!-- ============ 认证详情 ============ -->
    <div class="detail-page" v-else>
      <!-- 人员信息 -->
      <div class="person-card">
        <div class="avatar">
          <svg viewBox="0 0 24 24" class="avatar-icon"><circle cx="12" cy="8" r="4" fill="#c8c9cc"/><path d="M4 20 C4 15 8 13 12 13 C16 13 20 15 20 20 Z" fill="#c8c9cc"/></svg>
        </div>
        <div class="person-info">
          <div class="person-name">**杰</div>
          <div class="person-id">**************5619</div>
        </div>
        <span :class="['status-tag', current.certified ? 'tag-green' : 'tag-gray']">
          {{ current.certified ? '认证有效' : '未认证' }}
        </span>
      </div>

      <!-- 可办理：认证信息 + 须知 + 认证按钮 -->
      <template v-if="current.eligible">
        <div class="info-card">
          <div class="info-item">
            <span class="info-label">认证状态</span>
            <span class="info-value" :class="current.certified ? 'txt-green' : 'txt-orange'">
              {{ current.certified ? '已完成本年度认证' : '本年度尚未认证' }}
            </span>
          </div>
          <div class="info-item" v-if="current.lastDate">
            <span class="info-label">最近认证时间</span>
            <span class="info-value">{{ current.lastDate }}</span>
          </div>
          <div class="info-item" v-if="current.certified">
            <span class="info-label">待遇发放状态</span>
            <span class="info-value txt-green">正常发放</span>
          </div>
        </div>

        <div class="notice-card">
          <div class="notice-title">认证须知</div>
          <div class="notice-line">1. 待遇领取人员每年应完成一次待遇资格认证；</div>
          <div class="notice-line">2. 认证时请正对手机、保持光线充足，按提示完成眨眼、张嘴等动作；</div>
          <div class="notice-line">3. 逾期未认证将按规定暂停待遇发放，补认证后恢复并补发。</div>
        </div>

        <div class="footer-btn">
          <button class="submit-btn" @click="startAuth">{{ current.certified ? '再次认证' : '开始认证' }}</button>
        </div>
      </template>

      <!-- 不可办理：说明 -->
      <div class="empty-card" v-else>
        <img :src="emptyImg" class="empty-img" alt="暂不支持" />
        <div class="empty-text">{{ current.note }}</div>
        <div class="empty-sub">如对待遇资格有疑问，可拨打 12333 咨询</div>
      </div>
    </div>

    <!-- ============ 人脸识别模拟层 ============ -->
    <div class="auth-mask" v-if="authStage !== 'none'">
      <div class="auth-box">
        <template v-if="authStage === 'scanning'">
          <div class="face-ring">
            <svg viewBox="0 0 24 24" class="face-icon">
              <circle cx="12" cy="8.5" r="4" fill="none" stroke="#4DA6FF" stroke-width="1.6"/>
              <path d="M4.5 19.5 C4.5 15.5 8 13.5 12 13.5 C16 13.5 19.5 15.5 19.5 19.5" fill="none" stroke="#4DA6FF" stroke-width="1.6" stroke-linecap="round"/>
            </svg>
            <div class="scan-line"></div>
          </div>
          <div class="auth-text">正在进行人脸识别认证…</div>
          <div class="auth-sub">请保持面部在框内，按提示眨眼</div>
        </template>
        <template v-else>
          <div class="success-circle">
            <svg viewBox="0 0 24 24"><path d="M5 12.5 L10 17.5 L19 7" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div class="auth-text success">认证成功</div>
          <div class="auth-sub">{{ current.name }}待遇资格认证已完成</div>
          <div class="auth-date">认证时间：{{ todayStr }}</div>
          <button class="auth-done" @click="finishAuth">完成</button>
        </template>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'QualificationCertify',
  components: { SubPage },
  data() {
    return {
      emptyImg: require('@/assets/icons/social-empty.png'),
      view: 'list',
      current: {},
      // authStage: none | scanning | success
      authStage: 'none',
      authTimer: null,
      types: [
        {
          key: 'pension',
          name: '企业职工基本养老保险',
          eligible: true,
          certified: true,
          lastDate: '2026-06-15',
          note: ''
        },
        {
          key: 'resident',
          name: '城乡居民养老保险',
          eligible: false,
          certified: false,
          note: '您暂无城乡居民养老保险待遇领取信息，无需办理资格认证'
        },
        {
          key: 'gov',
          name: '机关事业单位养老保险',
          eligible: false,
          certified: false,
          note: '您暂无机关事业单位养老保险待遇领取信息，无需办理资格认证'
        },
        {
          key: 'injury',
          name: '工伤保险',
          eligible: false,
          certified: false,
          note: '您暂无工伤保险长期待遇领取信息，无需办理资格认证'
        }
      ]
    }
  },
  computed: {
    todayStr() {
      const d = new Date()
      const m = d.getMonth() + 1
      const day = d.getDate()
      return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day)
    }
  },
  beforeDestroy() {
    clearTimeout(this.authTimer)
  },
  methods: {
    openDetail(item) {
      this.current = item
      this.view = 'detail'
    },
    onPageBack() {
      if (this.view === 'detail') {
        this.view = 'list'
      } else {
        this.$router.back()
      }
    },
    startAuth() {
      this.authStage = 'scanning'
      clearTimeout(this.authTimer)
      // 模拟人脸检测过程
      this.authTimer = setTimeout(() => {
        this.authStage = 'success'
      }, 2400)
    },
    finishAuth() {
      this.authStage = 'none'
      // 更新当前险种认证状态
      const t = this.types.find(x => x.key === this.current.key)
      if (t) {
        t.certified = true
        t.lastDate = this.todayStr
      }
      this.current = Object.assign({}, this.current, { certified: true, lastDate: this.todayStr })
      this.$alert('待遇资格认证成功，您的待遇将正常发放')
    }
  }
}
</script>

<style scoped>
.certify-page {
  background: #F3F8FB;
  min-height: 100%;
}
.page-tip {
  font-size: calc(28 * var(--w));
  color: #969799;
  padding: calc(28 * var(--w)) calc(32 * var(--w)) calc(8 * var(--w));
}
.list-body {
  margin-top: calc(12 * var(--w));
  background: #fff;
}
.list-item {
  display: flex;
  align-items: center;
  min-height: calc(130 * var(--w));
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 calc(32 * var(--w));
  gap: calc(20 * var(--w));
  cursor: pointer;
}
.list-item:last-child {
  border-bottom: none;
}
.item-text {
  flex: 1;
  font-size: calc(32 * var(--w));
  color: #323233;
}
.status-tag {
  font-size: calc(24 * var(--w));
  padding: calc(6 * var(--w)) calc(18 * var(--w));
  border-radius: calc(24 * var(--w));
  flex-shrink: 0;
}
.tag-green {
  color: #07A35A;
  background: #E6F7EE;
}
.tag-orange {
  color: #D88230;
  background: #FDF1E5;
}
.tag-gray {
  color: #969799;
  background: #F2F3F5;
}
.arrow-icon {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
}

/* 详情页 */
.detail-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(160 * var(--w));
}
.person-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: calc(32 * var(--w));
  gap: calc(24 * var(--w));
}
.avatar {
  width: calc(100 * var(--w));
  height: calc(100 * var(--w));
  border-radius: 50%;
  background: #f2f2f2;
  overflow: hidden;
  flex-shrink: 0;
}
.avatar-icon {
  width: 100%;
  height: 100%;
}
.person-info {
  flex: 1;
}
.person-name {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(8 * var(--w));
}
.person-id {
  font-size: calc(28 * var(--w));
  color: #646566;
}
.info-card {
  margin-top: calc(20 * var(--w));
  background: #fff;
}
.info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: calc(104 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
}
.info-item:last-child {
  border-bottom: none;
}
.info-label {
  font-size: calc(30 * var(--w));
  color: #969799;
}
.info-value {
  font-size: calc(30 * var(--w));
  color: #323233;
}
.txt-green {
  color: #07A35A;
}
.txt-orange {
  color: #D88230;
}
.notice-card {
  margin: calc(20 * var(--w)) calc(24 * var(--w)) 0;
  background: #FFFBEF;
  border-radius: calc(12 * var(--w));
  padding: calc(28 * var(--w)) calc(32 * var(--w));
}
.notice-title {
  font-size: calc(30 * var(--w));
  font-weight: bold;
  color: #B07A1E;
  margin-bottom: calc(12 * var(--w));
}
.notice-line {
  font-size: calc(26 * var(--w));
  color: #8A6D3B;
  line-height: 1.9;
}
.footer-btn {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: calc(20 * var(--w)) calc(32 * var(--w)) calc(36 * var(--w));
  background: #fff;
}
.submit-btn {
  width: 100%;
  height: calc(92 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(12 * var(--w));
  cursor: pointer;
}
.empty-card {
  margin: calc(120 * var(--w)) calc(48 * var(--w)) 0;
  background: #fff;
  border-radius: calc(16 * var(--w));
  padding: calc(60 * var(--w)) calc(40 * var(--w));
  display: flex;
  flex-direction: column;
  align-items: center;
}
.empty-img {
  width: calc(300 * var(--w));
  height: calc(250 * var(--w));
  object-fit: contain;
}
.empty-text {
  margin-top: calc(24 * var(--w));
  font-size: calc(30 * var(--w));
  color: #646566;
  text-align: center;
  line-height: 1.6;
}
.empty-sub {
  margin-top: calc(16 * var(--w));
  font-size: calc(26 * var(--w));
  color: #969799;
}

/* 人脸识别层 */
.auth-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.72);
  z-index: 300;
  display: flex;
  align-items: center;
  justify-content: center;
}
.auth-box {
  width: calc(720 * var(--w));
  background: #fff;
  border-radius: calc(24 * var(--w));
  padding: calc(70 * var(--w)) calc(40 * var(--w)) calc(56 * var(--w));
  display: flex;
  flex-direction: column;
  align-items: center;
}
.face-ring {
  position: relative;
  width: calc(280 * var(--w));
  height: calc(280 * var(--w));
  border: calc(6 * var(--w)) solid #4DA6FF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.face-icon {
  width: calc(150 * var(--w));
  height: calc(150 * var(--w));
}
.scan-line {
  position: absolute;
  left: 0;
  right: 0;
  height: calc(6 * var(--w));
  background: linear-gradient(90deg, transparent, #4DA6FF, transparent);
  animation: scanMove 1.6s ease-in-out infinite alternate;
}
@keyframes scanMove {
  from { top: 12%; }
  to { top: 86%; }
}
.success-circle {
  width: calc(200 * var(--w));
  height: calc(200 * var(--w));
  border-radius: 50%;
  background: #07C160;
  display: flex;
  align-items: center;
  justify-content: center;
}
.success-circle svg {
  width: calc(110 * var(--w));
  height: calc(110 * var(--w));
}
.auth-text {
  margin-top: calc(44 * var(--w));
  font-size: calc(38 * var(--w));
  color: #323233;
  font-weight: 500;
}
.auth-text.success {
  color: #07C160;
}
.auth-sub {
  margin-top: calc(16 * var(--w));
  font-size: calc(28 * var(--w));
  color: #969799;
}
.auth-date {
  margin-top: calc(28 * var(--w));
  font-size: calc(26 * var(--w));
  color: #B5B5B5;
}
.auth-done {
  margin-top: calc(44 * var(--w));
  width: 100%;
  height: calc(92 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(12 * var(--w));
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/QualificationCertify.vue